class PWAManager {
  static instance;
  installPrompt = null;
  listeners = new Set();

  constructor() {
    this.setupEventListener();
  }

  static getInstance() {
    if (!PWAManager.instance) {
      PWAManager.instance = new PWAManager();
    }
    return PWAManager.instance;
  }

  setupEventListener() {
    if (typeof window !== 'undefined') {
      const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        this.setInstallPrompt(e);
        // Store a flag in localStorage to indicate prompt is available
        localStorage.setItem('pwaPromptAvailable', 'true');
      };

      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

      // Check if prompt was already captured
      if (window.deferredPrompt) {
        this.setInstallPrompt(window.deferredPrompt);
      }
    }
  }

  setInstallPrompt(prompt) {
    this.installPrompt = prompt;
    this.notifyListeners(prompt);
  }

  getInstallPrompt() {
    return this.installPrompt;
  }

  clearInstallPrompt() {
    this.installPrompt = null;
    localStorage.removeItem('pwaPromptAvailable');
    this.notifyListeners(null);
  }

  isPromptAvailable() {
    return this.installPrompt !== null || localStorage.getItem('pwaPromptAvailable') === 'true';
  }

  subscribe(callback) {
    this.listeners.add(callback);
    // Immediately call with current prompt if available
    if (this.installPrompt) {
      callback(this.installPrompt);
    }
  }

  unsubscribe(callback) {
    this.listeners.delete(callback);
  }

  notifyListeners(prompt) {
    this.listeners.forEach((callback) => callback(prompt));
  }

  async installApp() {
    if (!this.installPrompt) {
      return { success: false, message: 'No install prompt available' };
    }

    try {
      const choiceResult = await this.installPrompt.prompt();
      if (choiceResult.outcome === 'accepted') {
        localStorage.setItem('pwaPromptDismissed', 'true');
        this.clearInstallPrompt();
        return { success: true, message: 'App installed successfully!' };
      } else {
        return { success: false, message: 'Installation cancelled by user' };
      }
    } catch (error) {
      console.error('Error installing PWA:', error);
      return { success: false, message: 'Installation failed' };
    }
  }
}

export const pwaManager = PWAManager.getInstance();
